<template>
  <ContentMain />
</template>

<script>
import ContentMain from '@/components/Event/ContentMain'
export default {
  components: {
    ContentMain
  }
}
</script>
